import { render, staticRenderFns } from "./template-provider.vue?vue&type=template&id=7702bbf0&scoped=true"
import script from "./template-provider.vue?vue&type=script&lang=js"
export * from "./template-provider.vue?vue&type=script&lang=js"
import style0 from "./template-provider.vue?vue&type=style&index=0&id=7702bbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7702bbf0",
  null
  
)

export default component.exports